export const isArray = (arr: any) => Array.isArray(arr);
